export class PatientAccountBase {
  public patient_balance: number;
  public max_payment_allowed: number;
  public accept_balance_payments: boolean;
}
